function computeType({ type, t }) {
  return type?.split(',').map((tvalue) => t(`space:type.${tvalue}`)).join(', ');
}

export default computeType;
